import React from 'react';

import State from 'Common/renderers/State/State';

export const LastRunState: React.FC<{ lastRun: boolean }> = ({ lastRun }) => {
  if (lastRun === null) {
    return <State title="Unknown state of last run" className="status-yellow" text="Unknown" />;
  }

  if (lastRun) {
    return (
      <State
        title="All pipes in this flow succeeded in the last run"
        className="status-green"
        text="Success"
      />
    );
  }

  return (
    <State
      title="At least one pipe in this flow failed in the last run"
      className="status-red"
      text="Failure"
    />
  );
};
